import type { CategorizedHistory, SearchHistoryItem } from "./types";

export const categorizeByTime = (
  items: SearchHistoryItem[]
): CategorizedHistory => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const sevenDaysAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
  const thirtyDaysAgo = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000);

  return {
    today: items.filter((item) => item.date >= today),
    last7Days: items.filter(
      (item) => item.date < today && item.date >= sevenDaysAgo
    ),
    last30Days: items.filter(
      (item) => item.date < sevenDaysAgo && item.date >= thirtyDaysAgo
    ),
    older: items.filter((item) => item.date < thirtyDaysAgo),
  };
};
